import React, { useState } from "react";
import { Team } from "./InfoContext";

interface TeamCardProps {
  team: Team;
}

const TeamInfoCard: React.FC<TeamCardProps> = ({ team }) => {
  const [extended, setExtended] = useState(false);

  const handleExtendToggle = () => {
    setExtended(!extended);
  };

  return (
    <div className="flex flex-col p-2 sm:p-4 bg-white/10 rounded-xl min-w-md max-w-lg w-full">
      <div className="flex item-center justify-start gap-x-4">
        <div className="w-24 h-24 sm:w-44 sm:h-44 bg-white p-2 rounded-xl flex items-center justify-center">
          <img
            src={team.logo_url}
            alt={`${team.name_short} Logo`}
            className="w-full h-full object-contain rounded-xl"
          />
        </div>
        <div className="flex flex-col h-full justify-start text-white/80">
          <h3 className="text-2xl font-semibold text-white">{team.name}</h3>
          <p className="text-xl font-light">{team.name_short}</p>
          <p className="mt-4">
            Member since: {new Date(team.created_at).toLocaleDateString()}
          </p>
          <p className="">Captain: {team.captain?.name}</p>
          <p>Player count: {team.player_count}</p>
        </div>
        {/* <button
            className="w-full flex items-center bg-white/10 rounded-xl text-white  justify-center hover:bg-white/20"
            onClick={handleExtendToggle}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className={`size-6 transition-transform duration-200 ${
                extended ? "rotate-180" : ""
              }`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m19.5 8.25-7.5 7.5-7.5-7.5"
              />
            </svg>
          </button> */}
      </div>
      <div className="text-white">
        {extended && (
          <div className="flex flex-col gap-y-1">
            <h3 className="mt-2 text-xl font-semibold">Player</h3>
            {team.players.map((player) => (
              <div
                key={player.id}
                className="p-2 rounded-xl bg-white/10 w-full"
              >
                <span className="p-1 rounded-xl bg-white/20 mr-2">
                  {player.id}
                </span>
                {player.name}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamInfoCard;
